<template>
  <el-card class="campaign-list campaign-brush-list">
    <el-row :gutter="20" class="search-wrap">
      <el-col :md="3" class="search-item">
        <el-select
          v-model="params.status"
          :placeholder="$t('messages.myCampaign.list5')"
          clearable
        >
          <el-option
            v-for="(item, i) in asoGrowOption.asogrow_campaign_status"
            :key="i"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :md="4" class="search-item">
        <el-select
          v-model="params.business_type"
          :placeholder="$t('messages.myCampaign.list6')"
          clearable
        >
          <el-option
            v-for="item in brushTypes"
            :key="item.id"
            :label="$t(item.nameI18n)"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :md="4" class="search-item" v-if="isAgent">
        <el-input
          v-model="params.developer_name"
          :placeholder="$t('messages.myCampaign.list7')"
          style="min-width: 100px;"
        ></el-input>
      </el-col>
      <el-col :md="4" class="search-item">
        <el-input
          v-model="params.cpid"
          :placeholder="$t('messages.myCampaign.list8')"
          style="min-width: 115px;"
        ></el-input>
      </el-col>
      <el-col :md="3" class="search-item">
        <el-input
          v-model="params.package"
          :placeholder="$t('messages.myCampaign.list9')"
          style="min-width: 100px;"
        ></el-input>
      </el-col>
      <el-col :md="6" class="search-item-btn">
        <el-button type="primary" @click="getList">{{ $t('messages.myCampaign.list43') }}</el-button>
        <el-button type="primary" @click="add" class="create-btn">{{ $t('messages.myCampaign.list44') }}</el-button>
      </el-col>
    </el-row>
    <el-row class="mt-3 tableRow">
      <el-table
        v-loading="loading"
        :empty-text="$t('messages.myCampaign.list10')"
        :fit="true"
        border
        :data="list"
        class="campaignListTable"
      >
        <el-table-column :label="$t('messages.myCampaign.list19')" min-width="70" align="center">
          <template slot-scope="scope">
            <img
              :src="scope.row.icon"
              :class="showMobile ? 'icon1' : 'icon'"
              alt="icon"
              v-if="scope.row.icon"
            />
            <p class="img-d" v-else>--</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list8')" :min-width="showMobile ? 68 : 120" align="center">
          <template slot-scope="scope">
            <p
              @click="showCampaignDetail(scope.row.id)"
              style="color: #1861F2;font-size: 14px;cursor: pointer;"
            >
              {{ scope.row.id }}
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list7')" min-width="150" align="center" v-if="isAgent && !showMobile">
          <template slot-scope="scope">
            <p>{{ scope.row.developer_name || '--' }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list11')" min-width="160" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            {{ scope.row.app_name || '--' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list12')" min-width="200" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            {{ getBusinessTypeName(scope.row.business_type) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.createCampaignBrush.os')" min-width="160" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            {{ getOsLabel(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.createCampaignBrush.ranking')" min-width="90" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            {{ isRankingType(scope.row.business_type) ? getRankingLabel(scope.row) : '--' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.createCampaignBrush.promoteDays')" min-width="120" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            {{ isGuaranteedKeywordRanking(scope.row.business_type) ? getPromoteDaysLabel(scope.row) : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="country"
          :label="$t('messages.home.tip52')"
          min-width="90"
          align="center"
          v-if="!showMobile"
        >
          <template slot-scope="scope">
            {{ scope.row.country || '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          :label="$t('messages.myCampaign.list15')"
          min-width="110"
          align="center"
          v-if="!showMobile"
        >
          <template slot-scope="scope">
            <span>{{ getPriceLabel(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.createCampaignBrush.contact')" min-width="160" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            {{ getContactLabel(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list5')" align="center" :min-width="showMobile ? 67 : 100">
          <template slot-scope="scope">
            <p>{{ showLabel(scope.row.status, asoGrowOption.asogrow_campaign_status) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('messages.myCampaign.list14')"
          min-width="200"
          align="center"
          v-if="!showMobile"
        >
          <template slot-scope="scope">
            <span v-if="isKeywordInstall(scope.row.business_type) && scope.row.start && scope.row.end">
              {{ moment(scope.row.start).format('YYYY-MM-DD') }} ~ {{ moment(scope.row.end).format('YYYY-MM-DD') }}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('messages.myCampaign.list42')"
          fixed="right"
          align="center"
          :min-width="showMobile ? 70 : 200"
        >
          <template slot-scope="scope">
            <div class="actionWrap">
              <el-link
                type="primary"
                @click="repeat(scope.row)"
                v-if="showAction(scope.row.status, 'repeat')"
              >
                {{ $t('messages.myCampaign.list1') }}
              </el-link>
              <el-link
                style="margin-left: 16px;"
                type="primary"
                @click="changeStatus(scope.row, 4)"
                v-if="showAction(scope.row.status, 'active')"
              >
                Active
              </el-link>
              <el-link
                type="primary"
                style="margin-left: 16px;"
                @click="changeStatus(scope.row, 5)"
                v-if="showAction(scope.row.status, 'pause') && originalCountry.includes(scope.row.country)"
              >
                {{ $t('messages.myCampaign.list2') }}
              </el-link>
              <el-link
                type="primary"
                style="margin-left: 16px;"
                @click="changeStatus(scope.row, 6)"
                v-if="showAction(scope.row.status, 'cancel')"
              >
                {{ $t('messages.myCampaign.list3') }}
              </el-link>
              <el-link
                type="primary"
                style="margin-left: 16px;"
                v-if="showAction(scope.row.status, 'promote')"
                @click="promoteCheck(scope.row)"
              >
                {{ $t('messages.myCampaign.list18') }}
              </el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <pagination :page="page" @sizeChange="getList" @currentChange="getList"></pagination>

    <el-dialog
      class="campaign-confirm"
      :title="$t('messages.myCampaign.list38')"
      :visible.sync="confirmVisible"
      width="645px"
    >
      <div class="campaign-info">
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list19') }}:</div>
          <div class="value">
            <img :src="promoteCampaign.icon" alt="icon" width="32" height="32" />
          </div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list11') }}:</div>
          <div class="value">{{ promoteCampaign.app_name }}</div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list12') }}:</div>
          <div class="value">{{ getBusinessTypeName(promoteCampaign.business_type) }}</div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list22') }}:</div>
          <div class="value">{{ promoteCampaign.price }}</div>
        </div>
      </div>
      <div class="balance-tips" v-if="!balanceNotEnough">
        <p>{{ $t('messages.myCampaign.list23') }}</p>
        <p>{{ $t('messages.myCampaign.list24') }}, ${{ promoteCampaign.price }} {{ $t('messages.myCampaign.list25') }}</p>
      </div>
      <div class="balance-tips" v-if="balanceNotEnough">
        <p>{{ $t('messages.myCampaign.list23') }}</p>
        <p>{{ $t('messages.myCampaign.list24') }}, {{ $t('messages.myCampaign.list26') }}</p>
      </div>
      <div class="footer" slot="footer">
        <el-button type="primary" @click="promoteCreate" v-if="!balanceNotEnough">
          {{ $t('messages.myCampaign.list27') }}
        </el-button>
        <el-button type="primary" @click="goDeposit" v-if="balanceNotEnough">
          {{ $t('messages.myCampaign.list28') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog class="create-success" :title="$t('messages.createCampaign.create155')" :visible.sync="successVisible" width="600px">
      <div class="success-content">
        <p class="icon-success-box">
          <i class="iconfont icon-circle-check"></i>
        </p>
        <p class="success-text">{{ $t('messages.myCampaign.list29') }}</p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="viewCampaignList">{{ $t('messages.myCampaign.list30') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog class="create-fail" :title="$t('messages.deposit.deposit56')" :visible.sync="failVisible" width="600px">
      <div class="fail-content">
        <p class="icon-fail-box">
          <i class="iconfont icon-circle-close"></i>
        </p>
        <p class="fail-text">{{ $t('messages.myCampaign.list31') }}</p>
        <p class="fail-text">{{ $t('messages.myCampaign.list32') }}</p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="failVisible = false">{{ $t('messages.myCampaign.list53') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="cancel-confirm"
      :visible.sync="cancelVisible"
      width="604px"
      height="320px"
      :title="$t('messages.other.other36')"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="cancelCampaign"
        :model="form"
        :rules="rules"
        label-width="50px"
        style="padding: 0 20px;"
      >
        <el-form-item :label="$t('messages.support.support32')" prop="cancel_reason" class="cancel_reason">
          <el-input v-model="form.cancel_reason" type="textarea"></el-input>
        </el-form-item>
        <p style="color:#aaaaaa;margin-top: 38px;">
          {{ $t('messages.myCampaign.list55') }}
        </p>
      </el-form>
      <div class="footer" slot="footer">
        <el-button @click="cancelVisible = false">{{ $t('messages.other.other31') }}</el-button>
        <el-button @click="handleSubmit" type="primary" :disabled="btnDisabled">{{ $t('messages.deposit.deposit43') }}</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import moment from 'moment'
import { asogrowCN } from '@/js/varible'
import pagination from '../../components/pagination.vue'
import { throttleFn } from '@/js/common'

const BRUSH_TYPE_IDS = [30, 31, 32]
const OS_OPTIONS = [
  { id: 'Google Play', nameI18n: 'messages.createCampaignBrush.googlePlay' },
  { id: 'App Store on IPhone', nameI18n: 'messages.createCampaignBrush.appStoreIPhone' },
  { id: 'App Store on IPAD', nameI18n: 'messages.createCampaignBrush.appStoreIPad' },
  { id: 'android', nameI18n: 'messages.createCampaignBrush.googlePlay' },
  { id: 'iphone', nameI18n: 'messages.createCampaignBrush.appStoreIPhone' },
  { id: 'ipad', nameI18n: 'messages.createCampaignBrush.appStoreIPad' },
]
const RANKING_OPTIONS = [
  { id: 'Top1', nameI18n: 'messages.createCampaignBrush.top1' },
  { id: 'Top2', nameI18n: 'messages.createCampaignBrush.top2' },
  { id: 'Top3', nameI18n: 'messages.createCampaignBrush.top3' },
  { id: 'Top1-3', nameI18n: 'messages.createCampaignBrush.top1To3' },
  { id: 'Top4-6', nameI18n: 'messages.createCampaignBrush.top4To6' },
  { id: 'Top7-12', nameI18n: 'messages.createCampaignBrush.top7To12' },
  { id: 'Top13-25', nameI18n: 'messages.createCampaignBrush.top13To25' },
  { id: 'Top26-35', nameI18n: 'messages.createCampaignBrush.top26To35' },
  { id: 'Top36-50', nameI18n: 'messages.createCampaignBrush.top36To50' },
]
const PROMOTE_DAYS_OPTIONS = [
  { id: '2 weeks', nameI18n: 'messages.createCampaignBrush.weeks2' },
  { id: '3 weeks', nameI18n: 'messages.createCampaignBrush.weeks3' },
  { id: 'More', nameI18n: 'messages.createCampaignBrush.more' },
]
const CONTACT_OPTIONS = [
  { id: 'WhatsAPP', nameI18n: 'messages.profile.profile7' },
  { id: 'WhatsApp', nameI18n: 'messages.profile.profile7' },
  { id: 'Teams', nameI18n: 'messages.createCampaignBrush.teams' },
  { id: 'Telegram', nameI18n: 'messages.profile.profile6' },
  { id: 'Wechat', nameI18n: 'messages.profile.profile5' },
  { id: 'WeChat', nameI18n: 'messages.profile.profile5' },
]

export default {
  components: {
    pagination,
  },
  data() {
    return {
      moment,
      originalCountry: ['ID', 'IN', 'PH', 'US', 'NG', 'VN', 'TH', 'BR', 'MX', 'MY', 'BD', 'PK'],
      params: {
        status: '',
        business_type: '',
        cpid: '',
        package: '',
        developer_name: '',
      },
      loading: false,
      list: [],
      page: {
        tot: 0,
        cur: 1,
        per: 20,
      },
      asoGrowOption: {},
      asoGrowOptionEN: {},
      asogrowCN,
      brushTypes: [
        { id: 30, nameI18n: 'messages.createCampaign.create2' },
        { id: 31, nameI18n: 'messages.createCampaignBrush.typeIndustryListRanking' },
        { id: 32, nameI18n: 'messages.createCampaignBrush.typeGuaranteedKeywordRanking' },
      ],
      promoteCampaign: {},
      checkCampaign: {},
      confirmVisible: false,
      balanceNotEnough: false,
      successVisible: false,
      failVisible: false,
      cancelVisible: false,
      form: {
        cancel_reason: '',
      },
      rules: {
        cancel_reason: [this.createRequiredRule(this, 'messages.createCampaign.create140')],
      },
      cancelRow: {},
      showMobile: false,
    }
  },
  created() {
    if (this.$route.query.package) {
      this.params.package = this.$route.query.package
    }
    this.initPage()
    window.addEventListener('resize', this.move)
    let width = document.body.clientWidth || document.documentElement.clientWidth
    this.showMobile = width < 1025
  },
  mounted() {
    if (document.getElementById('elMain')) {
      document.getElementById('elMain').scrollTop = 0
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.move)
  },
  watch: {
    $route: function() {
      this.initPage()
    },
    isEnglish: {
      handler(newVal) {
        if (newVal) {
          this.asoGrowOption = this.asoGrowOptionEN
        } else {
          this.asoGrowOption = this.asogrowCN
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    isEnglish() {
      return this.$i18n.locale === 'en'
    },
    btnDisabled() {
      return this.form.cancel_reason === '' || this.form.cancel_reason === undefined
    },
    isAgent() {
      return this.$store.state.profile.customer_type === 1
    },
  },
  methods: {
    isKeywordInstall(type) {
      return Number(type) === 30
    },
    isRankingType(type) {
      return Number(type) === 31 || Number(type) === 32
    },
    isGuaranteedKeywordRanking(type) {
      return Number(type) === 32
    },
    getBusinessTypeName(type) {
      const item = this.brushTypes.find(i => i.id === Number(type))
      return item ? this.$t(item.nameI18n) : type || '--'
    },
    getRowExtra(row, key) {
      if (row[key] !== undefined && row[key] !== null && row[key] !== '') {
        return row[key]
      }
      const info = Array.isArray(row.info) ? row.info[0] : null
      return info && info[key] != null ? info[key] : ''
    },
    getI18nOptionLabel(list, id) {
      const item = list.find(i => String(i.id) === String(id))
      return item ? this.$t(item.nameI18n) : id || ''
    },
    getOsLabel(row) {
      return this.getI18nOptionLabel(OS_OPTIONS, this.getRowExtra(row, 'os')) || '--'
    },
    getRankingLabel(row) {
      return this.getI18nOptionLabel(RANKING_OPTIONS, this.getRowExtra(row, 'ranking')) || '--'
    },
    getPromoteDaysLabel(row) {
      const value = this.getRowExtra(row, 'promotion_option') || this.getRowExtra(row, 'promote_days')
      return this.getI18nOptionLabel(PROMOTE_DAYS_OPTIONS, value) || '--'
    },
    getContactLabel(row) {
      const typeName = this.getI18nOptionLabel(CONTACT_OPTIONS, this.getRowExtra(row, 'contact_type'))
      const number = this.getRowExtra(row, 'contact_value') || this.getRowExtra(row, 'contact_number')
      if (typeName && number) return `${typeName} ${number}`
      return number || typeName || '--'
    },
    getPriceLabel(row) {
      if (this.isRankingType(row.business_type)) {
        return '$300.00'
      }
      if (typeof row.price !== 'number') {
        return row.price || '--'
      }
      if (Number(row.price) === 0) {
        return 0
      }
      return `$${row.price.toFixed(2)}`
    },
    move() {
      let width = document.body.clientWidth || document.documentElement.clientWidth
      this.showMobile = width < 1025
    },
    initPage() {
      this.getOptions()
      this.getList()
    },
    add() {
      this.$router.push('/campaign/create-brush')
    },
    repeat(row) {
      this.$router.push({ path: '/campaign/create-brush', query: { type: 'repeat', id: row.id } })
    },
    showCampaignDetail(id) {
      window.open(`/campaign/create-brush?type=detail&id=${id}`, '_blank')
    },
    getOptions() {
      this.$http
        .get('/api/data/settings/', {
          params: {
            fields: 'asogrow',
          },
        })
        .then(data => {
          if (this.isEnglish) {
            this.asoGrowOption = data.data.asogrow
            this.asoGrowOptionEN = data.data.asogrow
          } else {
            this.asoGrowOption = this.asogrowCN
          }
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    getList() {
      this.loading = true
      if (this.params.cpid) {
        this.params.cpid = parseInt(this.params.cpid)
      }
      const query = {
        ...this.params,
        p: this.page ? this.page.cur : 1,
        n: this.page ? this.page.per : 20,
      }
      if (!query.business_type) {
        delete query.business_type
      }
      this.$http
        .get('/api/campaign/top_ranking_task/', {
          params: query,
        })
        .then(data => {
          this.loading = false
          this.list = (data.data || []).filter(item => BRUSH_TYPE_IDS.includes(Number(item.business_type)))
          this.changePageItem(this.page, data)
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    postChangeStatus: throttleFn(function(row, params) {
      this.$http
        .post(`/api/campaign/${row.id}/change_status/`, params)
        .then(() => {
          this.notifyOpen(this.$t('messages.createCampaign.create200'))
          row.status = params.status
          this.cancelVisible = false
        })
        .catch(error => {
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    }, 3000),
    changeStatus(row, status) {
      if (row.run_type === 0) {
        if (status === 6) {
          this.cancelVisible = true
          this.cancelRow = row
        } else {
          this.postChangeStatus(row, { status })
        }
      } else {
        this.notifyOpen(
          this.$t('messages.createCampaign.create198'),
          this.$t('messages.createCampaign.create199'),
          'error'
        )
      }
    },
    handleSubmit() {
      this.$refs.cancelCampaign.validate(valid => {
        if (valid) {
          this.postChangeStatus(this.cancelRow, {
            status: 6,
            cancel_reason: this.form.cancel_reason,
          })
        }
      })
    },
    promoteCheck(row) {
      this.promoteCampaign = row
      row.promoteLoading = true
      this.$http
        .post('/api/campaign/check/', { id: row.id })
        .then(data => {
          this.checkCampaign = data.data
          this.balanceNotEnough = !!this.checkCampaign.need_recharge
          this.confirmVisible = true
          row.promoteLoading = false
        })
        .catch(error => {
          if (error.c) {
            this.notifyOpen('Error', error.c, 'error')
          } else {
            this.notifyOpen('Error', this.executeError(error), 'error')
          }
          row.promoteLoading = false
        })
    },
    goDeposit() {
      this.confirmVisible = false
      const need = this.checkCampaign.need
      window.open(`/deposit?need=${need}`, '_blank')
    },
    promoteCreate() {
      this.$http
        .post('/api/campaign/promote/', { id: this.promoteCampaign.id })
        .then(() => {
          this.confirmVisible = false
          this.successVisible = true
          setTimeout(() => {
            this.$store.dispatch('getRealTimeInfo')
          }, 2000)
        })
        .catch(error => {
          switch (error.c) {
            case -2001:
              this.confirmVisible = false
              this.failVisible = true
              break
            default:
              this.notifyOpen('Error', this.executeError(error), 'error')
          }
        })
    },
    viewCampaignList() {
      this.successVisible = false
      this.getList()
    },
    showAction(status, action) {
      const actionMap = {
        repeat: [4, 5, 6, 7, 8, 9, 10],
        active: [5],
        pause: [4],
        cancel: [4, 5, 10],
        promote: [3],
      }
      return actionMap[action].includes(status)
    },
  },
}
</script>

<style lang="scss">
.campaign-brush-list {
  margin-bottom: 24px;
  a:hover {
    text-decoration: none;
  }
  .icon {
    width: 48px;
    height: 48px;
  }
  .icon1 {
    width: 24px;
    height: 24px;
  }
  .img-d {
    width: 48px;
    height: 48px;
    margin: 0 auto;
    line-height: 48px;
    text-align: center;
  }
  .search-item-btn {
    width: auto;
  }
}
@media screen and (max-width: 1025px) {
  .campaign-brush-list {
    .search-wrap {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .search-item {
        width: 50%;
        margin-bottom: 14px;
      }
      .search-item-btn {
        justify-content: space-between;
        display: flex;
        button {
          width: calc(50% - 10px);
          border-radius: 4px;
        }
      }
    }
    .campaignListTable {
      .actionWrap {
        display: flex;
        flex-direction: column;
        a {
          margin-left: 0 !important;
        }
      }
    }
  }
}
</style>
